module.exports = __webpack_public_path__ + "img/shangxianjilu1.28920d23.png";